import { relationships } from "@rocicorp/zero";
import { contact } from "./contact";
import { project } from "./project";
import { projectMember } from "./project-member";
import { ticket } from "./ticket";
import { workspace } from "./workspace";

/**
 * Relationships
 */
export const projectRelationships = relationships(project, ({ many, one }) => ({
	_tickets: many({
		sourceField: ["id"],
		destField: ["projectId"],
		destSchema: ticket,
	}),
	_workspace: one({
		sourceField: ["workspaceId"],
		destField: ["id"],
		destSchema: workspace,
	}),
	_relatedProject: one({
		sourceField: ["relatedProjectId"],
		destField: ["id"],
		destSchema: project,
	}),
	_client: one({
		sourceField: ["clientId"],
		destField: ["id"],
		destSchema: contact,
	}),
	_members: many({
		sourceField: ["id"],
		destField: ["projectId"],
		destSchema: projectMember,
	}),
}));
